module.exports = __webpack_public_path__ + "static/media/2area.82d35fb5.jpg";